// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__agFro","container":"Home_container__qFUYS","copy":"Home_copy__4ZhQr","copyText":"Home_copyText__2A3IH","copyLink":"Home_copyLink__S27q6"};